const FILES = "files";

export const filesKeys = {
	uploadImage: [FILES, "upload-image"] as const,
};
